<div class="content">
  <div class="title">
    <img
      class="logo"
      height="80"
      width="250"
      src="/images/logo.webp"
      alt="Georgian Bowl logo"
    >
    <span class="text">Great Deals. No Catch.</span>
    <span class="description">Limited-time offers, daily deals, and group bowling packages – all in one place.</span>
    <span class="green">Fresh deals drop often. Don’t miss out.</span>
  </div>

</div>
